<template>
  <div>
    <transition
        name="custom-classes-transition"
        enter-active-class="animate__animated animate__slideInRight"
        leave-active-class="animate__animated animate__slideOutRight"
        :duration="10">
      <div class="componentBrief" v-if="showFiltre">
        <filtre-liste-lignes-facture
              :fromProduit="produit !== null"/>
      </div>
    </transition>
    <div class="columns">
      <form @submit.prevent="recherche()"
            class="column is-narrow">
        <b-input :placeholder="$t('general.button.search')"
                  type="search"
                  icon="magnify"
                  v-model="critere.auto">
        </b-input>
      </form>
      <div class="column is-narrow">
        <button class="button" @click='showFiltreAndLock()'>
          <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
          <span class="is-size-7">{{$t('general.button.filtre')}}
            <label class="has-text-weight-bold"
                    :class="nombreCritere > 0 ? '' : 'is-invisible'">
              ({{ nombreCritere }})
            </label>
          </span>
        </button>
        <span @click="reinitialiser()"
          class="info-circle-right is-pulled-right is-cursor-pointer">
          <b-icon icon="close-circle" type="is-danger"></b-icon>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import filtreListeLignesFacture from '@/components/bodac/lignesFacture/filtreListeLignesFacture';
import { SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { RESET_CRITERE, SET_CRITERE } from '@/store/modules/bodac/factureParLigne-mutation-type';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';

const Societe = createNamespacedHelpers('societe');
const LignesFacture = createNamespacedHelpers('factureParLigne');

export default {
  name: 'ListeLignesFactureSearchBar',
  data() {
    return {
      showFiltre: false,
    };
  },
  props: {
    produit: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...LignesFacture.mapGetters({
      criteresRecherche: 'criteresRecherche',
    }),
    critere: {
      get() {
        return this.criteresRecherche;
      },
      set(newValue) {
        this.setCritereRecherche(newValue);
      },
    },
    nombreCritere() {
      const banCritere = ['autoRecherche', 'datesPremierAffichage', 'sens', 'interne'];
      if (this.produit) {
        banCritere.push('produitsIds');
      }
      let nbCritere = calculNombreCritere(this.critere, banCritere);
      if (this.critere.datesPremierAffichage) {
        nbCritere += this.critere.datesPremierAffichage.dateDebut ? 1 : 0;
        nbCritere += this.critere.datesPremierAffichage.dateFin ? 1 : 0;
      }
      if (this.critere.dateFacture) {
        nbCritere += this.critere.dateFacture.dateDebut ? 1 : 0;
        nbCritere += this.critere.dateFacture.dateFin ? 1 : 0;
      }
      nbCritere += this.critere.interne !== null ? 1 : 0;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
  },
  components: {
    filtreListeLignesFacture,
  },
  methods: {
    ...LignesFacture.mapMutations({
      resetCritereRecherche: RESET_CRITERE,
      setCritereRecherche: SET_CRITERE,
    }),
    recherche() {
      this.showFiltre = false;
      this.setLockMenu(false);
      this.$emit('recherche');
    },
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    showFiltreAndLock() {
      this.showFiltre = !this.showFiltre;
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter() {
      this.showFiltre = false;
      this.recherche();
    },
    async reinitialiser() {
      this.resetCritereRecherche();
      await updateCritereWithParametreInterne(this.critere);
      this.recherche();
    },
  },
};
</script>

<style>

</style>
